import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { actions } from 'src/redux'

import { RedirectionType, selectors } from '../redux/redirections/redux'

export const useRedirection = () => {
  const dispatch = useDispatch()
  const hasRedirected = useSelector(selectors.hasRedirected)
  const redirectUrl = useSelector(selectors.redirectUrl)
  const redirectType = useSelector(selectors.redirectType)
  const shouldRedirect = useSelector(selectors.shouldRedirect)

  const setRedirection = useCallback(
    (type: RedirectionType, url: string) => {
      dispatch(actions.redirections.setShouldRedirect(true))
      dispatch(actions.redirections.setRedirectType(type))
      dispatch(actions.redirections.setRedirectUrl(url))
    },
    [dispatch]
  )

  const setHasRedirected = useCallback(
    (value: boolean) => {
      dispatch(actions.redirections.hasRedirected(value))
    },
    [dispatch]
  )

  const resetRedirection = useCallback(() => {
    dispatch(actions.redirections.reset())
  }, [dispatch])

  return {
    hasRedirected,
    shouldRedirect,
    redirectType,
    redirectUrl,

    // Methods
    setRedirection,
    setHasRedirected,
    resetRedirection,
  }
}
